module.exports = __webpack_public_path__ + "img/Bumblebee.c5646dd2.png";